import { render, staticRenderFns } from "./editBoxofficeRecord.vue?vue&type=template&id=312d07bd&scoped=true&"
import script from "./editBoxofficeRecord.vue?vue&type=script&lang=js&"
export * from "./editBoxofficeRecord.vue?vue&type=script&lang=js&"
import style0 from "./editBoxofficeRecord.vue?vue&type=style&index=0&id=312d07bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d07bd",
  null
  
)

export default component.exports